// extracted by mini-css-extract-plugin
export default {"userImage":"userImage_userImage__rx9WW","logo":"userImage_logo__PUMA2"};